/*
 * NUHH automated discount filtering and sorting.
 * Reads the discount calculated in main-collection.liquid.
 */

const NUHH_FILTER_PARAM = 'discount_min';
const NUHH_SORT_PARAM = 'discount_sort';

/**
 * Check whether this is the Special Price collection.
 * Its handle must be: special-price
 */
function isNuhhSpecialPriceCollection() {
  const facetsForm = document.querySelector(
    'facets-form-component[data-collection-handle]'
  );

  return facetsForm?.dataset.collectionHandle === 'special-price';
}

/**
 * Apply the active discount filter and sorting order.
 */
function applyNuhhDiscountState(force = false) {
  const grid = document.querySelector(
    '#ResultsList [data-testid="product-grid"]'
  );

  if (!grid) return;

  const url = new URL(window.location.href);
  const specialPricePage = isNuhhSpecialPriceCollection();

  // Special Price automatically shows discounted pieces only.
  const minimumDiscount = Number(
    url.searchParams.get(NUHH_FILTER_PARAM) ||
      (specialPricePage ? 1 : 0)
  );

  // Special Price automatically sorts highest discount first.
  const discountSort =
    url.searchParams.get(NUHH_SORT_PARAM) ||
    (specialPricePage ? 'high-to-low' : 'default');

  const products = Array.from(
    grid.querySelectorAll(':scope > .product-grid__item')
  );

  const signature = `${minimumDiscount}-${discountSort}-${products.length}`;

  // Prevent the MutationObserver from creating an endless loop.
  if (!force && grid.dataset.nuhhDiscountState === signature) return;
  grid.dataset.nuhhDiscountState = signature;

  products.sort((productA, productB) => {
    const discountA = Number(productA.dataset.nuhhDiscount || 0);
    const discountB = Number(productB.dataset.nuhhDiscount || 0);

    if (discountSort === 'high-to-low') {
      return discountB - discountA;
    }

    if (discountSort === 'low-to-high') {
      return discountA - discountB;
    }

    // Restore the order supplied by Shopify.
    return (
      Number(productA.dataset.nuhhOriginalOrder || 0) -
      Number(productB.dataset.nuhhOriginalOrder || 0)
    );
  });

  const fragment = document.createDocumentFragment();
  let visibleProducts = 0;

  products.forEach((product) => {
    const discount = Number(product.dataset.nuhhDiscount || 0);
    const shouldShow = discount >= minimumDiscount;

    product.hidden = !shouldShow;
    product.style.display = shouldShow ? '' : 'none';

    if (shouldShow) visibleProducts += 1;

    fragment.appendChild(product);
  });

  grid.appendChild(fragment);

  updateNuhhDiscountFilterUI(minimumDiscount);
  updateNuhhProductCount(visibleProducts);
}

/**
 * Update the selected state and label inside the Discount dropdown.
 */
function updateNuhhDiscountFilterUI(minimumDiscount) {
  document.querySelectorAll('[data-nuhh-discount-panel]').forEach((panel) => {
    const buttons = panel.querySelectorAll('[data-nuhh-discount-min]');
    const status = panel.querySelector('[data-nuhh-discount-status]');
    let selectedLabel = '';

    buttons.forEach((button) => {
      const isSelected =
        Number(button.dataset.nuhhDiscountMin) === minimumDiscount;

      button.classList.toggle('is-active', isSelected);
      button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');

      if (isSelected) selectedLabel = button.textContent.trim();
    });

    panel.classList.toggle('is-active', minimumDiscount > 0);

    if (status) {
      status.textContent = minimumDiscount > 0 ? selectedLabel : '';
    }
  });
}

/**
 * Update Fabric's visible product count after discount filtering.
 */
function updateNuhhProductCount(visibleProducts) {
  document.querySelectorAll('[data-testid="products-count"] span').forEach(
    (count) => {
      count.textContent = `${visibleProducts} ${
        visibleProducts === 1 ? 'item' : 'items'
      }`;
    }
  );
}

/**
 * Select a discount threshold.
 */
document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;

  const discountButton = event.target.closest(
    '[data-nuhh-discount-min]'
  );

  if (discountButton) {
    event.preventDefault();

    const minimumDiscount = discountButton.dataset.nuhhDiscountMin;
    const url = new URL(window.location.href);

    url.searchParams.set(NUHH_FILTER_PARAM, minimumDiscount);
    history.replaceState({}, '', url);

    const panel = discountButton.closest('details');
    if (panel && window.innerWidth >= 750) panel.open = false;

    applyNuhhDiscountState(true);
    return;
  }

  const clearButton = event.target.closest('[data-nuhh-discount-clear]');

  if (clearButton) {
    event.preventDefault();

    const url = new URL(window.location.href);
    url.searchParams.delete(NUHH_FILTER_PARAM);
    history.replaceState({}, '', url);

    applyNuhhDiscountState(true);
  }
});

/**
 * Run when the page initially loads.
 */
document.addEventListener('DOMContentLoaded', () => {
  applyNuhhDiscountState(true);

  // Fabric replaces the collection grid after native filters are used.
  // Reapply the discount settings whenever that happens.
  let updateScheduled = false;

  const observer = new MutationObserver(() => {
    if (updateScheduled) return;
    updateScheduled = true;

    window.requestAnimationFrame(() => {
      updateScheduled = false;
      applyNuhhDiscountState();
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});

/**
 * Reapply if the customer uses the browser Back button.
 */
window.addEventListener('popstate', () => {
  applyNuhhDiscountState(true);
});

/**
 * Make the function available for the custom Sort options added next.
 */
window.NuhhDiscountCollection = {
  apply: applyNuhhDiscountState,
};